import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReportByIdApiResponse, ReportConfig, ReportsMetaDataResponse } from 'src/types/reportingTypes';
import { pushToast } from '../reportingSlice';
import { fetchReportsMetaData } from './fetchReportsMetaData';
import { RootState } from 'src/redux/store';

export const createReport = createAsyncThunk<
	void,
	createReportPayload,
	{ rejectValue: string, state: RootState }
>(
	'reporting/createReport',
	async ({ api, id, reqPayload }, { dispatch, rejectWithValue, getState }) => {
		try {
			const state = getState();
			const activeGraph = state.reporting.activeGraph;
			reqPayload.config = { ...reqPayload.config, chartType: activeGraph };
			await api.createUnifiedReport(id, reqPayload);

			// Use dispatch from the thunk context
			dispatch(
				pushToast({
					type: 'success',
					message: 'Report created successfully',
				}),
			);
			dispatch(fetchReportsMetaData({ api, id }));
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			dispatch(
				pushToast({
					type: 'error',
					message:
						'Error on creating report. Please try again after some time.',
				}),
			);
			return rejectWithValue(message);
		}
	},
);

export interface CreateUnifiedReportRequest {
    accountId: string;
    dataType: string;
    config: ReportConfig;
    name: string;
}

type createReportPayload = {
	api: {
		createUnifiedReport: (id: string, reqPayload: CreateUnifiedReportRequest) => Promise<ReportByIdApiResponse>;
		getUnifiedReportingMetaData: (
			id: string,
		) => Promise<ReportsMetaDataResponse>;
	};
	id: string;
	reqPayload: CreateUnifiedReportRequest;
};
